import { getCallable } from "../../_sdk/client";
import { apiName, endpoints } from "./endpoints";
import type {
    ApplyCollaborationInviteRequest, ApplyCollaborationInviteResponse
} from "./types";

export { apiName };

const applyCollaborationInvite = getCallable<ApplyCollaborationInviteRequest, ApplyCollaborationInviteResponse>(
    apiName,
    "applyCollaborationInvite",
    {
        ...endpoints.applyCollaborationInvite,
        composer: request => {
            return {
                url: `/workspaces/collaboration-invites/${request.inviteId}/apply`,
                options: {
                    method: "POST",
                    body: JSON.stringify(request)
                }
            };
        }
    });

export const callables = {
    applyCollaborationInvite
};
